export default __webpack_public_path__ + "static/SoftsoapBody-9e8f693a64ad0511a6707078c947c6e3.png";